import { styled } from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  height: 100%;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
`;

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(16, 1fr);
  grid-auto-rows: 1fr;
  height: 100%;
`;
